export const QuestionsData = {
    "www": [{
        "questionText": "How many times does our heart beat every day? (average)",
        "answerOptions": [{
            "answerText": "100,000 times",
            "isCorrect": true
        }, {
            "answerText": "200,000 times",
            "isCorrect": false
        }, {
            "answerText": "150,000 Times",
            "isCorrect": false
        }]
    }, {
        "questionText": " What does stress activate?",
        "answerOptions": [{
            "answerText": "somatic nervous system",
            "isCorrect": false
        }, {
            "answerText": "Sympathetic nervous system",
            "isCorrect": true
        }]
    }, {
        "questionText": "According to health experts, if young children consume a lot of fast food and sugary drinks, it can lead to:",
        "answerOptions": [{
            "answerText": "Obesity",
            "isCorrect": true
        }, {
            "answerText": "Stunted growth",
            "isCorrect": false
        }, {
            "answerText": "Fever and flu",
            "isCorrect": false
        }]
    }, {
        "questionText": " What does Arteriosclerosis refer to?",
        "answerOptions": [{
            "answerText": "Narrowing or thickening of arteries",
            "isCorrect": true
        }, {
            "answerText": "Increase in blood sugar level",
            "isCorrect": false
        }]
    }, {
        "questionText": "What can lead to a heart attack and strokes?",
        "answerOptions": [{
            "answerText": "arteriosclerosis",
            "isCorrect": true
        }, {
            "answerText": "hay fever",
            "isCorrect": false
        }, {
            "answerText": "biceps aching",
            "isCorrect": false
        }]
    }, {
        "questionText": " What can encourage your body to build new bypasses?",
        "answerOptions": [{
            "answerText": "Sports",
            "isCorrect": true
        }, {
            "answerText": "medication",
            "isCorrect": false
        }, {
            "answerText": "higher blood pressure",
            "isCorrect": false
        }]
    }, {
        "questionText": " Do painkillers and other freely available medicines have negative side effects?",
        "answerOptions": [{
            "answerText": "yes",
            "isCorrect": true
        }, {
            "answerText": "no",
            "isCorrect": false
        }]
    }, {
        "questionText": " Is it possible to die of a broken heart?",
        "answerOptions": [{
            "answerText": "yes",
            "isCorrect": true
        }, {
            "answerText": "no",
            "isCorrect": false
        }]
    }, {
        "questionText": " Obesity can also lead to depression, arthritis and certain types of cancer.",
        "answerOptions": [{
            "answerText": "TRUE",
            "isCorrect": true
        }, {
            "answerText": "FALSE",
            "isCorrect": false
        }]
    }, {
        "questionText": " Anxiety and stress release stress hormones like adrenaline in our bodies.",
        "answerOptions": [{
            "answerText": "TRUE",
            "isCorrect": true
        }, {
            "answerText": "FALSE",
            "isCorrect": false
        }]
    }],
    "hindi": [{
        "questionText": "क्या आपको पता है कि आपका दिल दिन में कितनी बार धड़कता है?1.",
        "answerOptions": [{
            "answerText": "1 लाख बार",
            "isCorrect": true
        }, {
            "answerText": "दो लाख बार",
            "isCorrect": false
        }, {
            "answerText": "डेढ़ लाख बार",
            "isCorrect": false
        }]
    }, {
        "questionText": " तनाव किसे एक्टिवेट कर देता है?",
        "answerOptions": [{
            "answerText": "सोमेटिक नर्वस सिस्टम को",
            "isCorrect": false
        }, {
            "answerText": "सिम्पैथेटिक नर्वस सिस्टम को",
            "isCorrect": true
        }]
    }, {
        "questionText": "स्वास्थ्य विशेषज्ञों के अनुसार, यदि छोटे बच्चे बहुत अधिक फास्ट फूड और मीठे पेय का सेवन करते हैं, तो यह हो सकता है",
        "answerOptions": [{
            "answerText": "मोटापा",
            "isCorrect": true
        }, {
            "answerText": "कम विकास",
            "isCorrect": false
        }, {
            "answerText": "फीवर और फ्लू",
            "isCorrect": false
        }]
    }, {
        "questionText": "आर्टिरियोस्केलेरोसिस का क्या मतलब है?",
        "answerOptions": [{
            "answerText": "धमनियों का संकरा हो जाना",
            "isCorrect": true
        }, {
            "answerText": "ब्लड शुगर का बढ़ जाना",
            "isCorrect": false
        }]
    }, {
        "questionText": "क्या हार्ट अटैक की वजह बन सकता है?",
        "answerOptions": [{
            "answerText": "आर्टिरियोस्केलेरोसिस",
            "isCorrect": true
        }, {
            "answerText": "हल्का बुखार",
            "isCorrect": false
        }, {
            "answerText": "मांसपेशियों का दर्द",
            "isCorrect": false
        }]
    }, {
        "questionText": "किस वजह से हमारे शरीर में नए बाइपास बन जाते हैं?",
        "answerOptions": [{
            "answerText": "खेल",
            "isCorrect": true
        }, {
            "answerText": "दवाइयों से",
            "isCorrect": false
        }, {
            "answerText": "हाई ब्लड प्रेशर",
            "isCorrect": false
        }]
    }, {
        "questionText": "पेनकिलर और सामान्य तौर पर उपलब्ध दवाओं से क्या कोई बुरा असर पड़ता है?",
        "answerOptions": [{
            "answerText": "हां",
            "isCorrect": true
        }, {
            "answerText": "नहीं",
            "isCorrect": false
        }]
    }, {
        "questionText": "क्या बीमार दिल की वजह से मौत भी हो सकती है?",
        "answerOptions": [{
            "answerText": "हां",
            "isCorrect": true
        }, {
            "answerText": "नहीं",
            "isCorrect": false
        }]
    }, {
        "questionText": "मोटापे से डिप्रेशन, अर्थराइटिस और खास तरह का कैंसर हो सकता है",
        "answerOptions": [{
            "answerText": "सही",
            "isCorrect": true
        }, {
            "answerText": "गलत",
            "isCorrect": false
        }]
    }, {
        "questionText": "चिंता और तनाव की वजह से स्ट्रेस हार्मोन रिलीज होते हैं",
        "answerOptions": [{
            "answerText": "सही ",
            "isCorrect": true
        }, {
            "answerText": "गलत",
            "isCorrect": false
        }]
    }],
    "tamil": [{
        "questionText": "இந்த வீடியோவில் எத்தனை முறை 'எறும்பு/எறும்புகள்' என்ற வார்த்தை பயன்படுத்தபட்டு இருந்தது ?",
        "answerOptions": [{
            "answerText": "9",
            "isCorrect": false
        }, {
            "answerText": "11",
            "isCorrect": true
        }, {
            "answerText": "12",
            "isCorrect": false
        }, {
            "answerText": "10",
            "isCorrect": false
        }]
    }, {
        "questionText": "இதில் எது ரோபோட்களால் நடக்க முடியாத பகுதி ?",
        "answerOptions": [{
            "answerText": "மண்",
            "isCorrect": false
        }, {
            "answerText": "தார் ரோடு",
            "isCorrect": false
        }, {
            "answerText": "பனிக்கட்டி",
            "isCorrect": true
        }, {
            "answerText": "சிமெண்ட் பாதை",
            "isCorrect": false
        }]
    }, {
        "questionText": "தீவிரமான சூரியப்புயல்கள் பூமியில் எதை பாதிக்கும் ?",
        "answerOptions": [{
            "answerText": "தொலைத்தொடர்பு",
            "isCorrect": true
        }, {
            "answerText": "மழைபொழிவு",
            "isCorrect": false
        }, {
            "answerText": "நிலச்சரிவு",
            "isCorrect": false
        }, {
            "answerText": "சுனாமி",
            "isCorrect": false
        }]
    }, {
        "questionText": "மது அருந்துவதால் விரைவில் எந்த நோய் வரும் ?",
        "answerOptions": [{
            "answerText": "இதயநோய்",
            "isCorrect": false
        }, {
            "answerText": "காசநோய்",
            "isCorrect": false
        }, {
            "answerText": "மறதி",
            "isCorrect": true
        }, {
            "answerText": "வலிப்பு",
            "isCorrect": false
        }]
    }, {
        "questionText": "சனி கோளின் வடதுருவத்தில் உள்ள புயலின் விட்டம் (diameter) எவ்வளவு கிலோ மீட்டர் ?",
        "answerOptions": [{
            "answerText": "18,000",
            "isCorrect": false
        }, {
            "answerText": "22,000",
            "isCorrect": false
        }, {
            "answerText": "31,000",
            "isCorrect": false
        }, {
            "answerText": "30,000",
            "isCorrect": true
        }]
    }, {
        "questionText": "பொம்மைகளில் எவ்வளவு சென்சார்கள் பதியப்பட்டுயுள்ளது ?",
        "answerOptions": [{
            "answerText": "6000க்கு மேல்",
            "isCorrect": true
        }, {
            "answerText": "1800க்கு மேல்",
            "isCorrect": false
        }, {
            "answerText": "3000க்கு மேல்",
            "isCorrect": false
        }, {
            "answerText": "7500க்கு மேல்",
            "isCorrect": false
        }]
    }, {
        "questionText": "பச்சை கிளியின் குஞ்சுகள் எப்படி பேச கற்றுக்கொள்கின்றன ?",
        "answerOptions": [{
            "answerText": "கத்துவதன் மூலம்",
            "isCorrect": false
        }, {
            "answerText": "கீச்சிடுவதன் மூலம்",
            "isCorrect": true
        }, {
            "answerText": "உளறுவதுன் மூலம்",
            "isCorrect": false
        }, {
            "answerText": "உறங்குவதன் மூலம்",
            "isCorrect": false
        }]
    }, {
        "questionText": "தட்டான் பூச்சிகள் எந்த திறனை கொண்டுள்ளன ?",
        "answerOptions": [{
            "answerText": "நடப்பது",
            "isCorrect": false
        }, {
            "answerText": "ஓடுவது",
            "isCorrect": false
        }, {
            "answerText": "உறங்குவது",
            "isCorrect": false
        }, {
            "answerText": "பறப்பது",
            "isCorrect": true
        }]
    }, {
        "questionText": "எவ்வளவு மணிநேரத்திற்கு ஒருமுறை சன் ஸ்க்ரீனை பயன்படுத்த வேண்டும் ?",
        "answerOptions": [{
            "answerText": "மூன்று",
            "isCorrect": false
        }, {
            "answerText": "ஒன்று",
            "isCorrect": false
        }, {
            "answerText": "இரண்டு",
            "isCorrect": true
        }, {
            "answerText": "நான்கு",
            "isCorrect": false
        }]
    }, {
        "questionText": "சந்திரனின் துருவ பகுதிகளில் குளிர் எவ்வளவு இருக்கும் ?",
        "answerOptions": [{
            "answerText": "-200°சி",
            "isCorrect": false
        }, {
            "answerText": "-240°சி",
            "isCorrect": true
        }, {
            "answerText": "-30°சி",
            "isCorrect": false
        }, {
            "answerText": "-110°சி",
            "isCorrect": false
        }]
    }, {
        "questionText": "நிலவில் எவ்வளவு நீர் இருக்கலாம் என்று கருதப்படுகின்றது ?",
        "answerOptions": [{
            "answerText": "270 பில்லியன் டன்கள்",
            "isCorrect": true
        }, {
            "answerText": "280 பில்லியன் டன்கள்",
            "isCorrect": false
        }, {
            "answerText": "220 பில்லியன் டன்கள்",
            "isCorrect": false
        }, {
            "answerText": "200 பில்லியன் டன்கள்",
            "isCorrect": false
        }]
    }, {
        "questionText": "நிலவில் ஓர் இரவு என்பது, பூமியில் எவ்வளவு நாட்களுக்கு சமம் ?",
        "answerOptions": [{
            "answerText": "11",
            "isCorrect": false
        }, {
            "answerText": "9",
            "isCorrect": false
        }, {
            "answerText": "5",
            "isCorrect": false
        }, {
            "answerText": "14",
            "isCorrect": true
        }]
    }, {
        "questionText": "நிலவை அடைய ஒரு விண்கலம் மணிக்கு எவ்வளவு கிலோமீட்டர் வேகத்தில் பயணிக்க வேண்டும் ?",
        "answerOptions": [{
            "answerText": "44000",
            "isCorrect": false
        }, {
            "answerText": "40000",
            "isCorrect": true
        }, {
            "answerText": "4000",
            "isCorrect": false
        }, {
            "answerText": "44400",
            "isCorrect": false
        }]
    }, {
        "questionText": "பல வெளிக்கோள்கள் எப்போது கண்டு பிடிக்கப்படுகின்றன ?",
        "answerOptions": [{
            "answerText": "நட்சத்திரைத்தை கடக்கும்போது",
            "isCorrect": true
        }, {
            "answerText": "சூரியனை கடக்கும்போது",
            "isCorrect": false
        }, {
            "answerText": "நிலவை கடக்கும்போது",
            "isCorrect": false
        }, {
            "answerText": "பூமியை கடக்கும்போது",
            "isCorrect": false
        }]
    }, {
        "questionText": "விண்வெளியில் உயிர் வாழக்கூடிய எவ்வளவு மில்லியன் கோள்கள் இருப்பதாக கூறப்படுகிறது ?",
        "answerOptions": [{
            "answerText": "300",
            "isCorrect": false
        }, {
            "answerText": "550",
            "isCorrect": false
        }, {
            "answerText": "500",
            "isCorrect": true
        }, {
            "answerText": "555",
            "isCorrect": false
        }]
    }, {
        "questionText": "விலங்குகள் கனவு காணுமா ?",
        "answerOptions": [{
            "answerText": "ஆம்",
            "isCorrect": true
        }, {
            "answerText": "இல்லை",
            "isCorrect": false
        }, {
            "answerText": "தெரியாது",
            "isCorrect": false
        }, {
            "answerText": "அப்படியா!",
            "isCorrect": false
        }]
    }, {
        "questionText": "ஐரோப்பாவின் சூரிய ஆய்வுக்கலன் எதை கண்டுபிடித்தது ?",
        "answerOptions": [{
            "answerText": "சூரிய பல்லி",
            "isCorrect": false
        }, {
            "answerText": "சூரிய தேள்",
            "isCorrect": false
        }, {
            "answerText": "சூரிய முதலை",
            "isCorrect": false
        }, {
            "answerText": "சூரிய பாம்பு",
            "isCorrect": true
        }]
    }, {
        "questionText": "ஒவ்வொரு மனிதருக்கும் நிகராக எத்தனை எறும்புகள் இருக்கின்றன ?",
        "answerOptions": [{
            "answerText": "35 லட்சம்",
            "isCorrect": false
        }, {
            "answerText": "22 லட்சம்",
            "isCorrect": false
        }, {
            "answerText": "25 லட்சம்",
            "isCorrect": true
        }, {
            "answerText": "15 லட்சம்",
            "isCorrect": false
        }]
    }, {
        "questionText": "எது சக்கரை மற்றும் மாவு சத்தை உண்ணுகிறது ?",
        "answerOptions": [{
            "answerText": "அல்கே",
            "isCorrect": false
        }, {
            "answerText": "பாக்டீரியா",
            "isCorrect": true
        }, {
            "answerText": "வைரஸ்",
            "isCorrect": false
        }, {
            "answerText": "பூஞ்சை",
            "isCorrect": false
        }]
    }, {
        "questionText": "ஜெல்லி மீன் ஆபத்தானதா ?",
        "answerOptions": [{
            "answerText": "ஆம்",
            "isCorrect": true
        }, {
            "answerText": "இல்லை",
            "isCorrect": false
        }, {
            "answerText": "தெரியாது",
            "isCorrect": false
        }, {
            "answerText": "இருக்கலாம்",
            "isCorrect": false
        }]
    }, {
        "questionText": "எந்த ஹார்மோன் நாய்களுக்கு ஆனந்த கண்ணீரை வர தூண்டுகிறது ?",
        "answerOptions": [{
            "answerText": "இன்சுலின்",
            "isCorrect": false
        }, {
            "answerText": "அட்ரினலின்",
            "isCorrect": false
        }, {
            "answerText": "தைய்ராய்டின்",
            "isCorrect": false
        }, {
            "answerText": "ஆக்சிடோசின்",
            "isCorrect": true
        }]
    }],
    "telugu": [{
        "questionText": "1 మన గుండె రోజుకు సగటున ఎన్నిసార్లు కొట్టుకుంటుంది..?",
        "answerOptions": [{
            "answerText": "a) 100,000 సార్లు",
            "isCorrect": true
        }, {
            "answerText": "b) 200,000 సార్లు",
            "isCorrect": false
        }, {
            "answerText": "c) 1,50,000 సార్లు",
            "isCorrect": false
        }]
    }, {
        "questionText": " ఒత్తిడి దేన్ని యాక్టివేట్ చేస్తుంది..?",
        "answerOptions": [{
            "answerText": "సొమాటిక్ నర్వస్ సిస్టం",
            "isCorrect": false
        }, {
            "answerText": " సింపాథెటిక్ నర్వస్ సిస్టం",
            "isCorrect": true
        }]
    }, {
        "questionText": " ఆరోగ్య నిపుణుల ప్రకారం చిన్నపిల్లలు ఎక్కువగా ఫాస్ట్ ఫుడ్ మరియు షుగర్ డ్రింక్స్ తీసుకోవడంవల్ల ఎలాంటి సమస్యలు వస్తాయి",
        "answerOptions": [{
            "answerText": "ఒబెసిటీ",
            "isCorrect": true
        }, {
            "answerText": "పెరుగుదల లోపం",
            "isCorrect": false
        }, {
            "answerText": "జ్వరం మరియు ఫ్లూ",
            "isCorrect": false
        }]
    }, {
        "questionText": "ఆర్టిరియోస్‌క్లిరాసిస్ అంటే ఏంటి..?",
        "answerOptions": [{
            "answerText": " ధమనులు సంకుచితం లేదా గట్టిపడటం",
            "isCorrect": true
        }, {
            "answerText": "బ్లడ్ షుగర్ లెవెల్స్ పెరగడం",
            "isCorrect": false
        }]
    }, {
        "questionText": " గుండె నొప్పులు లేదా స్ట్రోక్స్‌ ఎలా వస్తాయి..?",
        "answerOptions": [{
            "answerText": "ఆర్టిరియోస్‌క్లిరాసిస్",
            "isCorrect": true
        }, {
            "answerText": "గవత జ్వరం",
            "isCorrect": false
        }, {
            "answerText": "కండరాల నొప్పులు",
            "isCorrect": false
        }]
    }, {
        "questionText": " కొత్త బైపాస్‌లకు శరీరం సహకరించాలంటే..?",
        "answerOptions": [{
            "answerText": "క్రీడలు",
            "isCorrect": true
        }, {
            "answerText": "ఔషధాలు",
            "isCorrect": false
        }, {
            "answerText": "అధిక రక్తపోటు",
            "isCorrect": false
        }]
    }, {
        "questionText": "పెయిన్‌ కిల్లర్స్ అందుబాటులో ఉన్న ఇతర ఉచిత ఔషధాల్లో నెగిటివ్ సైడ్ ఎఫెక్ట్స్ ఉంటాయా..?",
        "answerOptions": [{
            "answerText": "అవును ",
            "isCorrect": true
        }, {
            "answerText": "కాదు",
            "isCorrect": false
        }]
    }, {
        "questionText": " విరిగిన హృదయంతో మనిషి మరణించే అవకాశాలున్నాయా..?",
        "answerOptions": [{
            "answerText": "అవును",
            "isCorrect": true
        }, {
            "answerText": "కాదు",
            "isCorrect": false
        }]
    }, {
        "questionText": " ఊబకాయం నిరాశ, ఆర్థ్రిటిస్ మరియు కొన్ని క్యాన్సర్లకు దారి తీస్తుంది",
        "answerOptions": [{
            "answerText": "వాస్తవం",
            "isCorrect": true
        }, {
            "answerText": "అవాస్తవం",
            "isCorrect": false
        }]
    }, {
        "questionText": " బాధ మరియు ఒత్తిళ్లు ఆడ్రినలైన్ లాంటి  స్ట్రెస్ హార్మోన్లు  విడుదల చేస్తాయి",
        "answerOptions": [{
            "answerText": "వాస్తవం",
            "isCorrect": true
        }, {
            "answerText": "అవాస్తవం",
            "isCorrect": false
        }]
    }],
    "kannada": [{
        "questionText": "ನಮ್ಮ ಹೃದಯವು ನಿತ್ಯ ಎಷ್ಟು ಬಾರಿ ಬಡಿದುಕೊಳ್ಳುತ್ತದೆ?(ಸರಾಸರಿ)",
        "answerOptions": [{
            "answerText": "ಎ) 1 ಲಕ್ಷ ಬಾರಿ",
            "isCorrect": true
        }, {
            "answerText": "ಬಿ)2 ಲಕ್ಷ ಬಾರಿ",
            "isCorrect": false
        }, {
            "answerText": "ಸಿ) 150,000 ಬಾರಿ",
            "isCorrect": false
        }]
    }, {
        "questionText": "ಒತ್ತಡವು ಏನನ್ನು ಸಕ್ರಿಯಗೊಳಿಸುತ್ತದೆ?",
        "answerOptions": [{
            "answerText": "ಎ) ಸೋಮ್ಯಾಟಿಕ್ ನರಮಂಡಲ ವ್ಯವಸ್ಥೆಯನ್ನು",
            "isCorrect": false
        }, {
            "answerText": "ಬಿ)ಸಿಂಪಥೆಟಿಕ್ ನರಮಂಡಲ ವ್ಯವಸ್ಥೆಯನ್ನು",
            "isCorrect": true
        }]
    }, {
        "questionText": "ಆರೋಗ್ಯ ತಜ್ಞರ ಪ್ರಕಾರ, ಚಿಕ್ಕ ಮಕ್ಕಳು ಫಾಸ್ಟ್‌ಫುಡ್ ಹಾಗೂ ಸಕ್ಕರೆ ಪಾನೀಯಗಳನ್ನು ಸೇವಿಸಿದರೆ ಈ ರೋಗಗಳಿಗೆ ತುತ್ತಾಗಬಹುದು?",
        "answerOptions": [{
            "answerText": "ಎ)ಬೊಜ್ಜು",
            "isCorrect": true
        }, {
            "answerText": "ಬಿ) ಕುಂಠಿತ ಬೆಳವಣಿಗೆ",
            "isCorrect": false
        }, {
            "answerText": "ಸಿ) ಜ್ವರ ಹಾಗೂ ಫ್ಲೂ",
            "isCorrect": false
        }]
    }, {
        "questionText": " ಆರ್ಟಿರಿಯೋಸ್ಕೆಲೆರೋಸಿಸಮ್ ಎಂದರೇನು?",
        "answerOptions": [{
            "answerText": "ಅಪಧಮನಿಗಳು ಕಿರಿದಾಗುವಿಕೆ ಅಥವಾ ದಪ್ಪವಾಗುವುದು",
            "isCorrect": true
        }, {
            "answerText": "ರಕ್ತದಲ್ಲಿನ ಸಕ್ಕರೆ ಮಟ್ಟದಲ್ಲಿ ಹೆಚ್ಚಳ",
            "isCorrect": false
        }]
    }, {
        "questionText": "5: ಹೃದಯಾಘಾತ ಹಾಗೂ ಪಾರ್ಶ್ವವಾಯುವಿಗೆ ಕಾರಣವೇನು?",
        "answerOptions": [{
            "answerText": "ಆರ್ಟಿರಿಯೋಸ್ಕೆಲೆರೋಸಿಸ್",
            "isCorrect": true
        }, {
            "answerText": "ಜ್ವರ",
            "isCorrect": false
        }, {
            "answerText": "ಸ್ನಾಯುಸೆಳೆತ ",
            "isCorrect": false
        }]
    }, {
        "questionText": " ನಿಮ್ಮ ಶರೀರದಲ್ಲಿ ಯಾವ ಕಾರಣಗಳಿಂದ ಹೊಸ ಬೈಪಾಸ್‌ಗಳು ನಿರ್ಮಾಣವಾಗುತ್ತವೆ?",
        "answerOptions": [{
            "answerText": "ಕ್ರೀಡೆ",
            "isCorrect": true
        }, {
            "answerText": "ಔಷಧಗಳು",
            "isCorrect": false
        }, {
            "answerText": "ಅತಿಯಾದ ರಕ್ತದೊತ್ತಡ",
            "isCorrect": false
        }]
    }, {
        "questionText": "ನೋವು ನಿವಾರಕಗಳು ಹಾಗೂ ಸುಲಭವಾಗಿ ಲಭ್ಯವಿರುವ ಔಷಧಿಗಳು ನಕಾರಾತ್ಮಕ ಅಡ್ಡಪರಿಣಾಮ ಹೊಂದಿದೆಯೇ?",
        "answerOptions": [{
            "answerText": "ಹೌದು",
            "isCorrect": true
        }, {
            "answerText": "ಇಲ್ಲ",
            "isCorrect": false
        }]
    }, {
        "questionText": "ಹೃದಯ ಸಂಬಂಧಿ ಕಾಯಿಲೆಯಿರುವವರು ಸಾಯುವ ಸಾಧ್ಯತೆ ಇದೆಯೇ?",
        "answerOptions": [{
            "answerText": "ಹೌದು ",
            "isCorrect": true
        }, {
            "answerText": "ಇಲ್ಲ",
            "isCorrect": false
        }]
    }, {
        "questionText": " ಬೊಜ್ಜು , ಖಿನ್ನತೆ, ಸಂಧಿವಾತ ಮತ್ತು ಹಲವು ರೀತಿಯ ಕ್ಯಾನ್ಸರ್‌ಗೆ ಕಾರಣವಾಗಬಹುದು",
        "answerOptions": [{
            "answerText": "ಸತ್ಯ",
            "isCorrect": true
        }, {
            "answerText": "ಸುಳ್ಳು",
            "isCorrect": false
        }]
    }, {
        "questionText": " ಆತಂಕ ಹಾಗೂ ಒತ್ತಡವು ನಮ್ಮ ದೇಹದಲ್ಲಿ ಅಡ್ರಿನಾಲಿನ್‌ನಂತಹ ಒತ್ತಡದ ಹಾರ್ಮೋನ್‌ಗಳನ್ನು ಬಿಡುಗಡೆ ಮಾಡುತ್ತದೆ",
        "answerOptions": [{
            "answerText": "ಸತ್ಯ",
            "isCorrect": true
        }, {
            "answerText": "ಸುಳ್ಳು",
            "isCorrect": false
        }]
    }],
    "malayalam": [{
        "questionText": " ദിവസത്തിൽ ശരാശരി എത്രതവണ ഹൃദയമിടിക്കാറുണ്ട്?",
        "answerOptions": [{
            "answerText": "1 ലക്ഷം തവണ",
            "isCorrect": true
        }, {
            "answerText": "2 ലക്ഷം തവണ",
            "isCorrect": false
        }, {
            "answerText": "1.5 ലക്ഷം തവണ",
            "isCorrect": false
        }]
    }, {
        "questionText": " സമ്മർദം ഏതു നാഡീവ്യൂഹത്തെയാണ് ഉണർത്തുക?",
        "answerOptions": [{
            "answerText": "സോമാറ്റിക് നാഡീവ്യൂഹം",
            "isCorrect": false
        }, {
            "answerText": "സിമ്പതിക നാഡീവ്യൂഹം",
            "isCorrect": true
        }]
    }, {
        "questionText": "ആരോഗ്യവിദഗ്ധരുടെ അഭിപ്രായത്തിൽ കുട്ടികൾ അമിതമായി ഫാസ്റ്റ്ഫുഡും പഞ്ചസാര അടങ്ങിയ പാനീയങ്ങളും കഴിക്കുകയാണെങ്കിൽ എന്തു സംഭവിക്കും?",
        "answerOptions": [{
            "answerText": "അമിതവണ്ണം",
            "isCorrect": true
        }, {
            "answerText": "മുരടിച്ച വളർച്ച",
            "isCorrect": false
        }, {
            "answerText": "പനിയും ജലദോഷവും",
            "isCorrect": false
        }]
    }, {
        "questionText": " ആർട്ടീരിയോസ്ക്ലീറോസിസ് എന്നാൽ?",
        "answerOptions": [{
            "answerText": "രക്തധമനികൾക്ക് കട്ടി കൂടുന്ന അവസ്ഥ",
            "isCorrect": true
        }, {
            "answerText": "രക്തത്തിൽ പഞ്ചസാരയുടെ അളവ് വർധിക്കുന്ന അവസ്ഥ",
            "isCorrect": false
        }]
    }, {
        "questionText": " ഹൃദയാഘാതത്തിന് കാരണമാവുന്നതെന്ത്?",
        "answerOptions": [{
            "answerText": "ആർട്ടീരിയോസ്ക്ലീറോസിസ്",
            "isCorrect": true
        }, {
            "answerText": "അലർജിക് റൈനൈറ്റിസ്",
            "isCorrect": false
        }, {
            "answerText": "കൈകാലുകളിലെ വേദന",
            "isCorrect": false
        }]
    }, {
        "questionText": " പുതിയ ബൈപാസുകൾ നിർമ്മിക്കാൻ ശരീരത്തെ പ്രോത്സാഹിപ്പിക്കുന്നതെന്താണ്?",
        "answerOptions": [{
            "answerText": "കായികാധ്വാനം",
            "isCorrect": true
        }, {
            "answerText": "മരുന്നുകളുടെ ഉപയോഗം",
            "isCorrect": false
        }, {
            "answerText": "ഉയർന്ന രക്തസമ്മർദ്ദം",
            "isCorrect": false
        }]
    }, {
        "questionText": " വേദനസംഹാരികൾ ഉൾപ്പെടെ എളുപ്പം ലഭ്യമാകുന്ന മരുന്നുകൾക്ക് പാർശ്വഫലങ്ങളുണ്ടോ?",
        "answerOptions": [{
            "answerText": "ഉണ്ട്",
            "isCorrect": true
        }, {
            "answerText": "ഇല്ല",
            "isCorrect": false
        }]
    }, {
        "questionText": " ഹൃദയം തകർന്നാൽ മരിക്കുമോ?",
        "answerOptions": [{
            "answerText": "മരിക്കും",
            "isCorrect": true
        }, {
            "answerText": "മരിക്കില്ല",
            "isCorrect": false
        }]
    }, {
        "questionText": " വിഷാദം, സന്ധിവാതം, ചിലതരം അർബുദം എന്നിവയ്ക്ക് അമിതവണ്ണം കാരണമാകും.",
        "answerOptions": [{
            "answerText": "ശരി",
            "isCorrect": true
        }, {
            "answerText": "തെറ്റ്",
            "isCorrect": false
        }]
    }, {
        "questionText": " ഉത്കണ്ഠയും മാനസിക സമ്മർദ്ദവും ശരീരത്തിൽ അഡ്രിനാലിൻ പോലുള്ള സ്ട്രെസ് ഹോർമോണുകൾ പുറപ്പെടുവിക്കും.\n",
        "answerOptions": [{
            "answerText": "ശരി",
            "isCorrect": true
        }, {
            "answerText": "തെറ്റ്",
            "isCorrect": false
        }]
    }]
};